import { useApiData } from "./useApiData"

const useSession = () => {
  const { data: session, error } = useApiData<{ csrf: string; error: boolean }>(
    `session/csrf`
  )
  return { session, error }
}

export default useSession
